var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "141px",
    viewBox: "0 0 150 141",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53FA6B94-F329-4C39-A56B-1E5839EE314B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9988159%",
    y1: "100%",
    x2: "49.9988159%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.7608548%",
    y1: "98.8803643%",
    x2: "39.2987348%",
    y2: "1.02948481%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9988159%",
    y1: "100%",
    x2: "49.9988159%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.9144422%",
    x2: "50%",
    y2: "-0.0855578371%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vendor-Registration-/-Section-2-/-Empty",
    transform: "translate(-360.000000, -229.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(290.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ct-no_data_qbuo",
    transform: "translate(70.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#E0E0E0",
    transform: "translate(63.234754, 69.432150) rotate(-12.110000) translate(-63.234754, -69.432150) ",
    points: "23.2048591 14.7717836 103.010739 14.9555535 103.26465 124.092516 23.4587696 123.908746"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(15.000000, 9.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(48.520056, 59.548831) rotate(-12.110000) translate(-48.520056, -59.548831) ",
    points: "10.267234 6.97098956 86.66515 7.04895953 86.7728787 112.126672 10.3749627 112.048702"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FAFAFA",
    transform: "translate(63.152438, 69.052982) rotate(-12.110000) translate(-63.152438, -69.052982) ",
    points: "25.4596964 17.4073722 100.605273 17.5804108 100.84518 120.698591 25.6996041 120.525553"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-2)",
    transform: "translate(52.314676, 18.644573) rotate(-12.110000) translate(-52.314676, -18.644573) ",
    points: "33.6648889 14.132752 70.9436688 14.2185943 70.9644628 23.1563949 33.685683 23.0705526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9294663,6.10743342 C46.2313776,6.67436481 44.5242807,9.32404117 45.1178252,12.025101 C45.7113696,14.7261609 48.3779427,16.459498 51.0707787,15.8925666 C53.7636147,15.3256352 55.4759643,12.6759588 54.8824198,9.97489897 C54.2888753,7.2738391 51.6275549,5.54050202 48.9294663,6.10743342 Z M50.6225563,13.8320878 C49.4562185,14.1041928 48.237502,13.6591104 47.5387871,12.7058773 C46.8400723,11.7526441 46.800191,10.4806639 47.4378739,9.48733278 C48.0755567,8.49400164 49.2640986,7.97669061 50.445291,8.17835909 C51.6264833,8.38002758 52.5656278,9.26060484 52.8216474,10.4065205 C52.9963154,11.1461893 52.8624888,11.9234561 52.4497777,12.5663443 C52.0370666,13.2092325 51.3794952,13.664742 50.6225563,13.8320878 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#03ADEB",
    transform: "translate(52.191565, 18.077398) rotate(-12.110000) translate(-52.191565, -18.077398) ",
    points: "33.9348557 13.7634923 70.4283963 13.8475264 70.4482737 22.3913046 33.9547331 22.3072705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9509428,6.11134459 C46.2516422,6.69076598 44.5330515,9.34886855 45.1123092,12.0484661 C45.691567,14.7480636 48.3493327,16.4669321 51.0486783,15.8877202 C53.7480239,15.3085083 55.4668208,12.6505392 54.8877725,9.95089668 C54.609675,8.65434849 53.827931,7.52140528 52.7145396,6.80133674 C51.6011482,6.0812682 50.2473268,5.83306784 48.9509428,6.11134459 L48.9509428,6.11134459 Z M50.6047356,13.8262488 C49.4637047,14.0711075 48.2875468,13.6044129 47.6247446,12.6438005 C46.9619424,11.6831882 46.9430359,10.4178523 47.5768417,9.43786216 C48.2106476,8.45787207 49.3723368,7.9562384 50.5201739,8.16689009 C51.6680111,8.37754178 52.5759278,9.25899063 52.8205316,10.4001869 C53.1544701,11.9581738 52.1624967,13.4919622 50.6047356,13.8262488 L50.6047356,13.8262488 Z",
    id: "Shape",
    fill: "#03ADEB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E0E0E0",
    x: 47,
    y: 22,
    width: 80,
    height: 109
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(49.000000, 23.000000)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.0509692671,
    y: 0.0217808219,
    width: 76.8634752,
    height: 105.892911
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 50,
    y: 24,
    width: 75,
    height: 104
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    x: 68,
    y: 19,
    width: 38,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,11 C84.2389629,11 82,13.238193 82,16 C82,18.761807 84.2389629,21 87,21 C89.7610371,21 92,18.761807 92,16 C92,13.238193 89.7610371,11 87,11 Z M87,18.8850103 C85.7993532,18.9128403 84.7009892,18.2278494 84.2216435,17.152298 C83.7422978,16.0767466 83.9774165,14.8247955 84.8163859,13.9854369 C85.6553552,13.1460782 86.9311218,12.8864428 88.0434894,13.3286785 C89.155857,13.7709141 89.883334,14.8269642 89.883672,16 C89.8953595,17.5691704 88.606485,18.8525245 87,18.871321 L87,18.8850103 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#03ADEB",
    x: 69,
    y: 19,
    width: 37,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0000731,11 C84.9777914,11 83.1546366,12.2181931 82.3807429,14.0865377 C81.6068492,15.9548824 82.0346218,18.1054401 83.4645908,19.5354092 C84.8945599,20.9653782 87.0451176,21.3931508 88.9134623,20.6192571 C90.7818069,19.8453634 92,18.0222086 92,15.9999269 C92,13.2385435 89.7614565,11 87.0000731,11 L87.0000731,11 Z M87.0000731,18.8856706 C85.4077215,18.8836901 84.1179186,17.5922768 84.1179186,15.999924 C84.1179186,14.4075712 85.4077319,13.1161625 87.0000834,13.1141854 C88.592435,13.1122128 89.8854446,14.4004184 89.8893971,15.9927663 C89.8889227,16.7584236 89.5841888,17.4925068 89.0422839,18.0334046 C88.5003789,18.5743023 87.76573,18.8776699 87.0000731,18.8767198 L87.0000731,18.8856706 Z",
    id: "Shape",
    fill: "#03ADEB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(1.000000, 133.000000)",
    fill: "#47E6B1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.10681818,
    y: 0.00681818182,
    width: 1,
    height: 2.90863636
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(2.535227, 1.461818) rotate(90.000000) translate(-2.535227, -1.461818) ",
    points: "2.27886364 -0.962045455 2.79159091 -0.962045455 2.79159091 3.88568182 2.27886364 3.88568182"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(81.000000, 0.000000)",
    fill: "#47E6B1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.06304348,
    y: 0,
    width: 1,
    height: 2.90863636
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(2.472826, 1.453636) rotate(90.000000) translate(-2.472826, -1.453636) ",
    points: "2.21646245 -0.864841897 2.72918972 -0.864841897 2.72918972 3.77211462 2.21646245 3.77211462"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.755203,139.525033 C140.371329,139.357928 140.173698,138.9296 140.295677,138.529095 C140.305187,138.499503 140.311188,138.468897 140.313557,138.437905 L140.313557,138.437905 C140.324512,138.256076 140.215057,138.088538 140.044144,138.025527 C139.87323,137.962515 139.681217,138.018909 139.571522,138.164335 L139.571522,138.164335 C139.552928,138.189243 139.537325,138.216249 139.525033,138.244797 C139.357928,138.628671 138.9296,138.826302 138.529095,138.704323 C138.499503,138.694813 138.468897,138.688812 138.437905,138.686443 L138.437905,138.686443 C138.256076,138.675488 138.088538,138.784943 138.025527,138.955856 C137.962515,139.12677 138.018909,139.318783 138.164335,139.428478 L138.164335,139.428478 C138.189243,139.447072 138.216249,139.462675 138.244797,139.474967 C138.628671,139.642072 138.826302,140.0704 138.704323,140.470905 C138.694813,140.500497 138.688812,140.531103 138.686443,140.562095 L138.686443,140.562095 C138.675488,140.743924 138.784943,140.911462 138.955856,140.974473 C139.12677,141.037485 139.318783,140.981091 139.428478,140.835665 L139.428478,140.835665 C139.447072,140.810757 139.462675,140.783751 139.474967,140.755203 C139.642072,140.371329 140.0704,140.173698 140.470905,140.295677 C140.500497,140.305187 140.531103,140.311188 140.562095,140.313557 L140.562095,140.313557 C140.743924,140.324512 140.911462,140.215057 140.974473,140.044144 C141.037485,139.87323 140.981091,139.681217 140.835665,139.571522 L140.835665,139.571522 C140.810757,139.552928 140.783751,139.537325 140.755203,139.525033 Z",
    id: "Path",
    fill: "#4D8AF0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7552029,102.525033 C24.3713289,102.357928 24.1736981,101.9296 24.295677,101.529095 C24.3051869,101.499503 24.3111881,101.468897 24.3135574,101.437905 L24.3135574,101.437905 C24.3245124,101.256076 24.2150573,101.088538 24.0441438,101.025527 C23.8732302,100.962515 23.6812173,101.018909 23.5715215,101.164335 L23.5715215,101.164335 C23.5529284,101.189243 23.5373252,101.216249 23.5250325,101.244797 C23.3579283,101.628671 22.9296001,101.826302 22.5290952,101.704323 C22.4995035,101.694813 22.4688971,101.688812 22.4379053,101.686443 L22.4379053,101.686443 C22.256076,101.675488 22.0885385,101.784943 22.025527,101.955856 C21.9625154,102.12677 22.0189094,102.318783 22.1643354,102.428478 L22.1643354,102.428478 C22.1892433,102.447072 22.2162489,102.462675 22.2447971,102.474967 C22.6286711,102.642072 22.8263019,103.0704 22.704323,103.470905 C22.6948131,103.500497 22.6888119,103.531103 22.6864426,103.562095 L22.6864426,103.562095 C22.6754876,103.743924 22.7849427,103.911462 22.9558562,103.974473 C23.1267698,104.037485 23.3187827,103.981091 23.4284785,103.835665 L23.4284785,103.835665 C23.4470716,103.810757 23.4626748,103.783751 23.4749675,103.755203 C23.6420717,103.371329 24.0703999,103.173698 24.4709048,103.295677 C24.5004965,103.305187 24.5311029,103.311188 24.5620947,103.313557 L24.5620947,103.313557 C24.743924,103.324512 24.9114615,103.215057 24.974473,103.044144 C25.0374846,102.87323 24.9810906,102.681217 24.8356646,102.571522 L24.8356646,102.571522 C24.8107567,102.552928 24.7837511,102.537325 24.7552029,102.525033 Z",
    id: "Path",
    fill: "#FDD835",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.755203,12.5250325 C121.371329,12.3579283 121.173698,11.9296001 121.295677,11.5290952 C121.305187,11.4995035 121.311188,11.4688971 121.313557,11.4379053 L121.313557,11.4379053 C121.324512,11.256076 121.215057,11.0885385 121.044144,11.025527 C120.87323,10.9625154 120.681217,11.0189094 120.571522,11.1643354 L120.571522,11.1643354 C120.552928,11.1892433 120.537325,11.2162489 120.525033,11.2447971 C120.357928,11.6286711 119.9296,11.8263019 119.529095,11.704323 C119.499503,11.6948131 119.468897,11.6888119 119.437905,11.6864426 L119.437905,11.6864426 C119.256076,11.6754876 119.088538,11.7849427 119.025527,11.9558562 C118.962515,12.1267698 119.018909,12.3187827 119.164335,12.4284785 L119.164335,12.4284785 C119.189243,12.4470716 119.216249,12.4626748 119.244797,12.4749675 C119.628671,12.6420717 119.826302,13.0703999 119.704323,13.4709048 C119.694813,13.5004965 119.688812,13.5311029 119.686443,13.5620947 L119.686443,13.5620947 C119.675488,13.743924 119.784943,13.9114615 119.955856,13.974473 C120.12677,14.0374846 120.318783,13.9810906 120.428478,13.8356646 L120.428478,13.8356646 C120.447072,13.8107567 120.462675,13.7837511 120.474967,13.7552029 C120.642072,13.3713289 121.0704,13.1736981 121.470905,13.295677 C121.500497,13.3051869 121.531103,13.3111881 121.562095,13.3135574 L121.562095,13.3135574 C121.743924,13.3245124 121.911462,13.2150573 121.974473,13.0441438 C122.037485,12.8732302 121.981091,12.6812173 121.835665,12.5715215 L121.835665,12.5715215 C121.810757,12.5529284 121.783751,12.5373252 121.755203,12.5250325 L121.755203,12.5250325 Z",
    id: "Path",
    fill: "#FDD835",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    opacity: 0.5,
    cx: 149,
    cy: 57,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    opacity: 0.5,
    cx: 43,
    cy: 135,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    opacity: 0.5,
    cx: 134,
    cy: 87,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4D8AF0",
    opacity: 0.5,
    cx: 16,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#47E6B1",
    opacity: 0.5,
    cx: 1,
    cy: 54,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyList);
export default __webpack_public_path__ + "static/media/emptyList.5be5e0b1.svg";
export { ForwardRef as ReactComponent };